// extracted by mini-css-extract-plugin
export default {"activeText":"ActiveClients_activeText__w21Z1","activeClientsPopover":"ActiveClients_activeClientsPopover__dH+j3"};